module.exports = __webpack_public_path__ + "img/2_33.2c412d05.png";